import { render, staticRenderFns } from "./export-columns.vue?vue&type=template&id=772fac68&scoped=true&"
import script from "./export-columns.vue?vue&type=script&lang=js&"
export * from "./export-columns.vue?vue&type=script&lang=js&"
import style0 from "./export-columns.vue?vue&type=style&index=0&id=772fac68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772fac68",
  null
  
)

export default component.exports